import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-67168327"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "channel-description"
}
const _hoisted_2 = {
  key: 0,
  class: "animate modal"
}
const _hoisted_3 = { class: "modal-inner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Editar Descripción", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Cuéntanos un poco sobre tí. (Máximo: 255 caracteres)", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 1,
  class: "latest-messages-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Ver todos", -1))
const _hoisted_10 = { class: "latest-messages" }
const _hoisted_11 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_12 = {
  key: 2,
  class: "latest-messages-container"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Ver todos", -1))
const _hoisted_14 = { class: "latest-messages" }
const _hoisted_15 = {
  key: 0,
  style: {"margin-top":"10px"}
}

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import EditChannelHeader from '@/components/channel/EditChannelHeader.vue'
import CodeBite from '@/components/cards/CodeBite.vue'
import CodePost from '@/components/cards/CodePost.vue'
import ProfileService from '@/services/ProfileService'
import ChannelService from '@/services/ChannelService'
import { ref, onMounted,Ref } from 'vue'
import { useAuth } from '@/store/useAuth'
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import router from '@/router'
import main from '@/data/main.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialProfileEditView',
  setup(__props) {

const profileService = new ProfileService()
const user = ref()
const loading = ref(true)
const store = useAuth()
const showEditDescription = ref(false)
const description = ref('')
const toast = useToast()
const codebites:Ref<any> = ref([])
const codeposts:Ref<any> = ref([])
const channelService = new ChannelService()

onMounted(async () => {
    if (!store.token) { return }
    loading.value = true
    user.value = await profileService.MyUser(store.token)
    codebites.value = await channelService.GetLatestCodeBitesFromAuthUser(store.token, 4)
    codeposts.value = await channelService.GetLatestCodePostsFromAuthUser(store.token, 2)
    loading.value = false
})

const refresh = async () => {
    if (!store.token) { return }
    codebites.value = await channelService.GetLatestCodeBitesFromAuthUser(store.token, 4)
    codeposts.value = await channelService.GetLatestCodePostsFromAuthUser(store.token, 2)
}

const handleDescription = async () => {
    if (!store.token) { return }
    if (description.value.length < 3 || description.value.length > 255) {
        toast.showToast("El tamaño de la descripción no es válido", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }
    const response = await profileService.UpdateDescription(store.token, description.value)
    if (response == true) {
        toast.showToast("Perfil Actualizado.", Toast.SUCCESS)
        setTimeout(function () { toast.hideToast() }, 4000);
        user.value = await profileService.MyUser(store.token)
        showEditDescription.value = false
    } else {
        toast.showToast("Error al actualizar.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
    }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createVNode(EditChannelHeader),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (showEditDescription.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", {
                      style: {"float":"right","cursor":"pointer"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showEditDescription.value = false))
                    }, [
                      _createVNode(_component_v_icon, {
                        name: "ri-close-circle-fill",
                        fill: "lightcoral"
                      })
                    ]),
                    _hoisted_4,
                    _hoisted_5,
                    _withDirectives(_createElementVNode("input", {
                      class: "input-text",
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
                      placeholder: "Nueva Descripción",
                      maxlength: "255",
                      max: "255"
                    }, null, 512), [
                      [_vModelText, description.value]
                    ]),
                    _createElementVNode("button", {
                      class: "new-question",
                      onClick: handleDescription
                    }, "Actualizar Descripción")
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("h3", null, [
              _createTextVNode("Sobre " + _toDisplayString(user.value.name) + " ", 1),
              _createVNode(_component_v_icon, {
                class: "pencil",
                name: "bi-pencil-fill",
                style: {"overflow-y":"hidden"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showEditDescription.value = true))
              })
            ]),
            (user.value.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(user.value.description), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_7, "Bienvenido al canal de " + _toDisplayString(user.value.name) + " en " + _toDisplayString(_unref(main).NAME_COMPANY_FOOTER), 1))
          ]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("h3", null, [
              _createTextVNode("Últimos Shorts de " + _toDisplayString(user.value.name) + " ", 1),
              _createVNode(_component_RouterLink, {
                to: { name: 'my-codebites' },
                style: {"text-decoration":"none"}
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createTextVNode(),
              _createElementVNode("button", {
                class: "new-question",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push({ name: 'new-codebite' })))
              }, "Crear un nuevo ")
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codebites.value, (codebite) => {
                return (_openBlock(), _createBlock(CodeBite, {
                  key: codebite.id,
                  codebite: codebite,
                  user: user.value,
                  onRefresh: refresh
                }, null, 8, ["codebite", "user"]))
              }), 128)),
              (codebites.value.length == 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(user.value.name) + " no ha publicado Shorts", 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("h3", null, [
              _createTextVNode("Últimos Posts de " + _toDisplayString(user.value.name) + " ", 1),
              _createVNode(_component_RouterLink, {
                to: { name: 'my-codeposts' },
                style: {"text-decoration":"none"}
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createTextVNode(),
              _createElementVNode("button", {
                class: "new-question",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push({ name: 'new-codepost' })))
              }, "Crear un nuevo Post")
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codeposts.value, (codepost) => {
                return (_openBlock(), _createBlock(CodePost, {
                  key: codepost.id,
                  codepost: codepost,
                  user: user.value,
                  onRefresh: refresh
                }, null, 8, ["codepost", "user"]))
              }), 128)),
              (codeposts.value.length == 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(user.value.name) + " no ha publicado Posts", 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})